import React from 'react';
import ResultCard from './ResultCard';
import './SelectionCard.css';

function SelectionCard({
  selected,
  onSelect,
  title,
  image,
  description,
  link,
  showTitle,
  publicationDate,
  ...rest
}) {
  return (
    <div
      className={`selection-card${selected ? ' selected' : ''}`}
      onClick={onSelect}
      {...rest}
    >
      <ResultCard
        title={title}
        image={image}
        description={description}
        link={link}
        showTitle={showTitle}
        publicationDate={publicationDate}
      />
    </div>
  );
}

export default SelectionCard;
